var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg34(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "url(#paint0_linear_2460_2519)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9941 18.5352V37.2852H33.6191L17.9941 18.5352Z",
    fill: "url(#paint1_linear_2460_2519)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.36914 37.2852H17.9941V18.5352L2.36914 37.2852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 45C14.3239 48.2522 19.5895 50.0074 25 50C30.625 50 35.8242 48.1367 40 45H10Z",
    fill: "#FF2D55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 40C6.42773 41.8906 8.10938 43.5723 10 45H40C41.8906 43.5723 43.5723 41.8906 45 40H5Z",
    fill: "#FC9965"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5371 35H2.08789C2.86133 36.7734 3.83789 38.4531 5 40H33.5508V35H33.5391H33.5371Z",
    fill: "#FFBC5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6309 29.9414V43.6914H48.0937L36.6309 29.9414Z",
    fill: "url(#paint2_linear_2460_2519)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1816 43.6914H36.6309V29.9414L25.1816 43.6914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5371 22.5C36.9889 22.5 39.7871 19.7018 39.7871 16.25C39.7871 12.7982 36.9889 10 33.5371 10C30.0853 10 27.2871 12.7982 27.2871 16.25C27.2871 19.7018 30.0853 22.5 33.5371 22.5Z",
    fill: "#FFC95B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7129 12.5C19.4388 12.5 20.8379 11.1009 20.8379 9.375C20.8379 7.64911 19.4388 6.25 17.7129 6.25C15.987 6.25 14.5879 7.64911 14.5879 9.375C14.5879 11.1009 15.987 12.5 17.7129 12.5Z",
    fill: "#FFC95B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6797 37.9707L42.3379 42.418V25.4883L34.6797 37.9707Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3379 25.4883V42.418L49.9961 37.9707L42.3379 25.4883Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3398 34.5527L49.9961 37.9707L42.3398 42.416V34.5508V34.5527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3379 34.5527H42.3398V42.418H42.3379L34.6797 37.9727L42.3379 34.5527Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6797 39.3984L42.3379 50V43.8437L34.6797 39.3984Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3379 43.8437V50L50 39.3984L42.3379 43.8437Z",
    fill: "#878787"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2460_2519",
    x1: 42.6953,
    y1: 7.33594,
    x2: 7.32813,
    y2: 42.7031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2460_2519",
    x1: 25.8013,
    y1: 18.542,
    x2: 25.8013,
    y2: 37.2891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A524B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2D55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2460_2519",
    x1: 40.8784,
    y1: 29.9432,
    x2: 40.8784,
    y2: 43.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A524B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2D55"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg34);
export default __webpack_public_path__ + "static/media/34.89109d32d884f98d993824fe1c9a5933.svg";
export { ForwardRef as ReactComponent };